import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteComment } from "../../../firebase/commentsApi";
import { adjustPendingCommentDeltas, incrementPostCommentCount } from "../postSlice.js";

export const removeComment = createAsyncThunk(
  "comments/removeComment",
  async ({ commentId }, { rejectWithValue, dispatch, getState }) => {
    const slice = getState().comments;
    let postId = null;
    let foundComment = null;

    // Find postId and comment from state
    for (const pid of Object.keys(slice.items || {})) {
      const found = slice.items[pid]?.find((c) => c.id === commentId);
      if (found) {
        postId = pid;
        foundComment = found;
        break;
      }
    }

    // Prefer loaded replies when available; fall back to stored replyCount on the comment
    const repliesState = getState().replies;
    const loadedActiveCount = Array.isArray(repliesState?.items?.[commentId])
      ? repliesState.items[commentId].filter((r) => !r?.deletedAt).length
      : 0;
    const storedReplyCount =
      typeof foundComment?.replyCount === "number" ? foundComment.replyCount : 0;
    const activeReplyCount = Math.max(loadedActiveCount, storedReplyCount);

    const dec = 1 + activeReplyCount;

    if (postId) {
      dispatch(
        adjustPendingCommentDeltas({
          postId,
          commentCount: -dec,
          topLevelCommentCount: -1,
        }),
      );
      dispatch(incrementPostCommentCount({ postId, delta: -dec }));
    }

    try {
      await deleteComment(commentId);

      if (postId) {
        dispatch(
          adjustPendingCommentDeltas({
            postId,
            commentCount: dec,
            topLevelCommentCount: 1,
          }),
        );
      }

      return { commentId, postId };
    } catch (error) {
      if (postId) {
        dispatch(
          adjustPendingCommentDeltas({
            postId,
            commentCount: dec,
            topLevelCommentCount: 1,
          }),
        );
        dispatch(incrementPostCommentCount({ postId, delta: dec }));
      }
      return rejectWithValue(error.message);
    }
  },
);
